import { Paper, Typography } from '@mui/material';
import Iconify from '../../../../reusable-components/iconify';

export default function ReportIsDownloadingCard() {

  return <Paper sx={{ width: '100%', pt: 2, px: 2 }}>    
    <Typography sx={{ pt: 2, textAlign: 'center' }} variant="h6" color="info.main">
      <Iconify icon="line-md:downloading-loop" color="info" width={48} height={48} sx={{ mx: -1 }} />
    </Typography>
    <Typography sx={{ pt: 2, textAlign: 'center' }} variant="h6" color="info.main">
      Your download is in progress.
    </Typography>
    <Typography sx={{ textAlign: 'center' }} variant="h6" color="info.main">
      This may take a few minutes.
    </Typography>  
  </Paper>;
}